import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationSystemUsersService,
  PageModelAdminDriverModel,
  AdminUserModel,
  ProfileStatus,
  PageModelAdminUserModel,
  AdminUserListRequest,
  PageModelBaseUserDataModel
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationSystemUsersApiService {
  constructor(private apiService: AdministrationSystemUsersService) {}

  public getDriversListByEmail(value: string, loadId?: string, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAdminDriverModel> {
    return this.apiService.adminDriversListByEmail({ value }, loadId, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setUserStatus(userId: string, status: ProfileStatus, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminUserModel> {
    return this.apiService.adminUsersEditStatus(userId, status, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getUser(userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminUserModel> {
    return this.apiService.adminUsersGet(userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getUsersList(body: AdminUserListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAdminUserModel> {
    return this.apiService.adminUsersList(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getUsersListByEmail(value: string, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelBaseUserDataModel> {
    return this.apiService.adminUsersListByEmail({ value }, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
